/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

* This template has been built upon, with additional code and configuration by Tazi Rides Ltd.
*/

// @mui material components
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'

import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

function Billing(): JSX.Element {
	return (
		<Card id="profile">
			<MDBox p={2}>
				<Grid container spacing={3} alignItems="center">
					<Grid item>
						<MDBox height="100%" mt={0.5} lineHeight={1}>
							<MDTypography variant="h5" fontWeight="medium">
								Upcoming Invoice
							</MDTypography>
						</MDBox>
					</Grid>
					<Grid item xs={12} md={6} lg={3} sx={{ ml: 'auto' }}>
						<MDBox
							display="flex"
							justifyContent={{ md: 'flex-end' }}
							alignItems="center"
							lineHeight={1}
							gap={8}
						>
							<MDBox mr={5} alignItems="center" display={'flex'} flexDirection={'column'}>
								<MDTypography component="h6" variant="button" fontWeight="medium">
									£N/A
								</MDTypography>
							</MDBox>
						</MDBox>
					</Grid>
				</Grid>
			</MDBox>
		</Card>
	)
}

export default Billing
